import { gql } from "@apollo/client";

// Define the GraphQL query for fetching library card index tags
export const GET_LIBRARY_CARD_INDEX_TAGS_QUERY = gql`
  query GetLibraryCardIndexTags($input: LibraryCardIndexTagsInput!) {
    getLibraryCardIndexTags(input: $input) {
      tags
    }
  }
`;
